import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

export const SubmitButton = ({ label }) => (
  <button className="submit-button btn primary big" type="submit">
    <Label message={label} />
  </button>
);

SubmitButton.propTypes = {
  label: PropTypes.string.isRequired,
};
